module.exports = function (core) {
  const delta = 1096032 - 306 + 1
  const offset = 306

  return function () {
    const r = core['integer']({ delta: delta, offset: offset })
    const s = core['integer']({ delta: 86400000 })
    let d = r * 86400000 + s
    return new Date(d)
  }
}



// WEBPACK FOOTER //
// ./src/private/handlers/date.js